import * as React from "react";
import type { SVGProps } from "react";
const SvgButtonEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#050033"
      fillOpacity={0.2}
      d="M4.167 2.5A1.66 1.66 0 0 0 2.5 4.167v11.666A1.666 1.666 0 0 0 4.167 17.5h11.666a1.666 1.666 0 0 0 1.667-1.667V10h-1.667v5.833H4.167V4.167H10V2.5zm10.65.833a.57.57 0 0 0-.4.167L13.4 4.508l2.083 2.084L16.5 5.583a.563.563 0 0 0 0-.791L15.208 3.5a.56.56 0 0 0-.391-.167M12.808 5.1l-6.141 6.15v2.083H8.75l6.142-6.15z"
    />
  </svg>
);
export default SvgButtonEdit;
